<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark color="primary">
        <v-toolbar-title class="white--text pl-2">{{ tempItem.name ? tempItem.name : '新規作成' }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card flat>
        <v-card-text class="overflow-y-auto" style="max-height:600px;">
          <v-row align="center" class="ma-0">
            <v-col cols="12" class="pa-0">
              <v-text-field
                ref="school"
                label="*名称"
                v-model="tempItem.name"
                :rules="[rules.required]"
                :disabled="type == 'view'"
                class="title"
                @change="modified = true"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-text-field
                ref="zip"
                v-model="tempItem.zip"
                label="郵便番号"
                append-outer-icon="search"
                type="text"
                @click:append-outer="onSearch()"
                @keyup.enter.native="onSearch()"
                :disabled="type == 'view'"
                @change="modified = true"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pa-0"></v-col>
            <v-col cols="12" class="pa-0">
              <v-text-field
                ref="address"
                v-model="tempItem.address"
                label="住所"
                :disabled="type == 'view'"
                @change="modified = true"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-text-field
                ref="address2"
                v-model="tempItem.address2"
                label="住所（番地・建屋名称・部屋番号）"
                :disabled="type == 'view'"
                @change="modified = true"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click.native="onClose()">取消</v-btn>
          <v-btn rounded depressed color="primary" @click.native="onCreate()">{{ tempItem.key ? '変更' : '登録' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae'
    })
  },
  props: [ 'type', 'item' ],
  data () {
    return {
      modified: false,
      loading: false,
      school: null,
      tempItem: null,
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  created () {
    if (!this.item) {
      this.tempItem = JSON.parse(JSON.stringify(this.$store.getters['scholae/initial']))
      var index = this.users.findIndex(user => user.key === this.user.uid)
      if (index !== -1) {
        for (var key in this.users[index].schools) {
          if (this.users[index].schools[key]) {
            var i = this.schools.findIndex(school => school.key === key)
            if (i !== -1) {
              this.school = this.schools[i]
              this.tempItem.schools[this.school.key] = true
            }
          }
        }
      }
    } else {
      this.tempItem = JSON.parse(JSON.stringify(this.item))
    }
  },
  methods: {
    onClose () {
      this.$emit('dismissed')
    },
    onCreate () {
      var vm = this
      var payload = JSON.parse(JSON.stringify(this.tempItem))
      if (this.$refs.school.validate(true)) {
        vm.loading = true
        if (!payload.key) {
          payload['createdAt'] = parseInt(new Date().getTime())
        }
        payload['updatedAt'] = parseInt(new Date().getTime())
        this.$store.dispatch('scholae/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
          vm.onClose()
        })
      }
    },
    onSearch () {
      var vm = this
      if (this.tempItem.zip === '' || this.tempItem.zip.length < 7) {
        return
      }
      this.loading = true
      var payload = this.tempItem.zip
      this.$store.dispatch('postcode/search', payload).then(function (data) {
        if (data) {
          vm.tempItem.address = data.val().a7
        } else {
          vm.tempItem.address = null
          vm.tempItem.address2 = null
        }
        vm.loading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
